import styled from '@emotion/styled';

import {
  blockingColors,
  blockingMetrics,
  blockingTypography,
} from 'design-system/tokens';

const { mobileBreakpoint } = blockingMetrics;

export const CallCenterRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  width: 100%;

  @media (max-width: ${mobileBreakpoint}) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

export const HeadsetCircle = styled.span`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 100px;
  background: #e5e7ff;
  color: ${blockingColors.actionBlue};

  svg {
    width: 28px;
    height: 28px;
  }
`;

export const ModalSubtitle = styled.p`
  margin: 0;
  font-family: ${blockingTypography.fontFamily};
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: ${blockingColors.textStrong};
  text-align: left;

  @media (max-width: ${mobileBreakpoint}) {
    text-align: center;
  }
`;

export const ContactList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;

  @media (max-width: ${mobileBreakpoint}) {
    align-items: center;
  }
`;

export const ContactLine = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  font-family: ${blockingTypography.fontFamily};
  font-size: ${blockingTypography.modalBody.size};
  font-weight: ${blockingTypography.modalBody.weight};
  line-height: ${blockingTypography.modalBody.lineHeight};
  color: ${blockingColors.textStrong};
  text-align: left;

  @media (max-width: ${mobileBreakpoint}) {
    justify-content: center;
    text-align: center;
  }
`;

export const PhoneIconLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: ${blockingColors.actionBlue};

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const ConsultantRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  width: 100%;

  @media (max-width: ${mobileBreakpoint}) {
    flex-direction: column;
    align-items: center;
  }
`;

export const ConsultantAvatar = styled.div`
  flex-shrink: 0;
  width: 96px;
  height: 96px;
  border-radius: 100px;
  background: ${blockingColors.iconCircle};
  background-size: cover;
  background-position: center;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ConsultantName = styled.p`
  margin: 0;
  font-family: ${blockingTypography.fontFamily};
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: ${blockingColors.textStrong};
  text-align: left;

  @media (max-width: ${mobileBreakpoint}) {
    text-align: center;
  }
`;

export const ConsultantContact = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;

  @media (max-width: ${mobileBreakpoint}) {
    align-items: center;
  }
`;

export const CompensationList = styled.ul`
  align-self: flex-start;
  width: 100%;
  margin: 0;
  padding-left: 20px;
  font-family: ${blockingTypography.fontFamily};
  font-size: ${blockingTypography.modalBody.size};
  line-height: ${blockingTypography.modalBody.lineHeight};
  color: ${blockingColors.textStrong};

  li + li {
    margin-top: 4px;
  }
`;

export const CompensationDetail = styled.p`
  margin: 0;
  font-family: ${blockingTypography.fontFamily};
  font-size: ${blockingTypography.modalBody.size};
  font-weight: 700;
  line-height: ${blockingTypography.modalBody.lineHeight};
  color: ${blockingColors.textStrong};
`;

export const BaseList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const BaseItem = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  padding: 16px;
  background: ${blockingColors.surface};
  border-radius: ${blockingMetrics.radius};

  @media (max-width: ${mobileBreakpoint}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const BaseInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  min-width: 0;

  @media (max-width: ${mobileBreakpoint}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
  }
`;

export const PinCircle = styled.span`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 1000px;
  background: ${blockingColors.iconCircle};
  color: ${blockingColors.iconGlyph};

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const BaseTexts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  min-width: 0;
`;

export const BaseName = styled.strong`
  font-family: ${blockingTypography.fontFamily};
  font-size: ${blockingTypography.cardTitle.size};
  font-weight: ${blockingTypography.cardTitle.weight};
  line-height: ${blockingTypography.cardTitle.lineHeight};
  color: ${blockingColors.text};
`;

export const BaseAddress = styled.span`
  font-family: ${blockingTypography.fontFamily};
  font-size: 14px;
  line-height: 20px;
  color: ${blockingColors.text};
`;

export const ModalActionButton = styled.button`
  box-sizing: border-box;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${blockingMetrics.actionWidth};
  min-width: 98px;
  max-width: ${blockingMetrics.actionMaxWidth};
  height: ${blockingMetrics.actionHeight};
  padding: 12px 16px;
  border: 1px solid ${blockingColors.actionBlue};
  border-radius: ${blockingMetrics.radiusPill};
  background: ${blockingColors.actionBlue};
  font-family: ${blockingTypography.fontFamily};
  font-size: ${blockingTypography.actionLabel.size};
  font-weight: ${blockingTypography.actionLabel.weight};
  line-height: ${blockingTypography.actionLabel.lineHeight};
  color: ${blockingColors.white};
  cursor: pointer;

  @media (max-width: ${mobileBreakpoint}) {
    width: 100%;
    max-width: none;
  }
`;

export const SlipsTableWrap = styled.div`
  width: 100%;
  overflow-x: auto;

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: ${blockingTypography.fontFamily};
    font-size: 14px;
    color: ${blockingColors.text};
  }

  th,
  td {
    padding: 12px 8px;
    text-align: left;
    white-space: nowrap;
  }

  th {
    font-weight: 700;
  }

  tbody tr:nth-of-type(odd) {
    background: ${blockingColors.surface};
  }
`;

export const EmptyMessage = styled.p`
  margin: 0;
  font-family: ${blockingTypography.fontFamily};
  font-size: 14px;
  line-height: 20px;
  color: ${blockingColors.text};
  text-align: center;
`;

export const SlipActionsCell = styled.td`
  position: relative;
  text-align: right;
`;

export const MenuTrigger = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: ${blockingMetrics.radius};
  background: transparent;
  color: ${blockingColors.iconGlyph};
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;

  &:hover,
  &:focus-visible {
    background: ${blockingColors.surface};
    color: ${blockingColors.textStrong};
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;
